import { Matrix34 } from '@seddi/math-v2';
import { Box3, Sphere, Vector3 } from '@seddi/three';
import { assert } from '@/core/assert';
import { createFromBounds } from './cameraLookAt';
export const computeCamera = (() => {
    const bbox = new Box3();
    const bsphere = new Sphere();
    const size = new Vector3();
    return (scene, fov, screenRatio = 1) => {
        const { boundingBox } = scene;
        assert(boundingBox, 'Style scene descriptor must have a precomputed bounding box');
        // Use scene bounding box
        const { max, min } = scene.boundingBox;
        bbox.set(min, max);
        // Axix-independent bounding box to sphere conversion
        bbox.getCenter(bsphere.center);
        bbox.getSize(size);
        const axis = Math.max(size.x, size.y, size.z);
        bsphere.radius = axis * 0.5;
        return createFromBounds(bsphere, fov, screenRatio);
    };
})();
export const computeCameraWithAngle = (() => {
    const m0 = new Matrix34();
    const m1 = new Matrix34();
    const m2 = new Matrix34();
    return (scene, fov, angle, screenRatio = 1) => {
        const camera = computeCamera(scene, fov, screenRatio);
        m0.makeTranslation(camera.target);
        m1.makeRotationY(angle);
        m2.makeTranslationFromFloats(-camera.target.x, -camera.target.y, -camera.target.z);
        m0.multiplyInPlace(m1).multiplyInPlace(m2);
        m0.transformRef(camera.origin);
        return camera;
    };
})();
